// File: src/pages/NewsletterPage.js
// This page is updated with an improved date/time selector.
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function NewsletterPage() {
  const initialFormState = { id: null, subject: '', body: '', scheduleDate: '', scheduleTime: '' };
  const [formData, setFormData] = useState(initialFormState);
  const [isEditing, setIsEditing] = useState(false);
  
  const [newsletters, setNewsletters] = useState([
    { id: 1, subject: 'Welcome to the R.A.W. Fitness Family!', date: '2025-07-20', recipients: 150, status: 'Sent', body: 'This is the full body of the welcome email.' },
    { id: 2, subject: 'This Week: New HIIT Workouts Added!', date: '2025-07-27', recipients: 180, status: 'Sent', body: 'Check out our latest high-intensity workouts!' },
    { id: 3, subject: 'Monthly Roundup - July', date: 'Not Sent', recipients: 0, status: 'Draft', body: 'This is a draft for the July roundup.' },
  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [viewingNewsletter, setViewingNewsletter] = useState(null);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleView = (newsletter) => {
    setViewingNewsletter(newsletter);
    setIsModalOpen(true);
  };

  const handleEdit = (draft) => {
    setFormData({ id: draft.id, subject: draft.subject, body: draft.body, scheduleDate: '', scheduleTime: '' });
    setIsEditing(true);
  };
  
  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this draft?')) {
        setNewsletters(newsletters.filter(item => item.id !== id));
    }
  };

  const handleCancelEdit = () => {
    setFormData(initialFormState);
    setIsEditing(false);
  };

  const handleSubmit = (status) => {
    let finalStatus = status;
    let finalDate = status === 'Sent' ? new Date().toISOString().slice(0, 10) : 'Not Sent';

    if (formData.scheduleDate && formData.scheduleTime) {
        finalStatus = `Scheduled for ${formData.scheduleDate} at ${formData.scheduleTime}`;
        finalDate = 'Scheduled';
    }

    if (isEditing) {
        setNewsletters(newsletters.map(n => n.id === formData.id ? { ...n, ...formData, status: finalStatus, date: finalDate } : n));
        alert(`Draft updated and saved as ${finalStatus}!`);
    } else {
        const newNewsletter = { ...formData, id: Date.now(), status: finalStatus, date: finalDate };
        setNewsletters([newNewsletter, ...newsletters]);
        alert(`Newsletter saved as ${finalStatus}!`);
    }
    handleCancelEdit();
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <header className="bg-black shadow-md">
        <div className="container mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <img src="/Logo.png" alt="R.A.W. Fitness Logo" className="h-12 w-auto" />
            <h1 className="text-xl font-bold text-lime">Newsletter Management</h1>
          </div>
          <nav><Link to="/admin" className="text-white hover:text-lime transition duration-300">Back to Dashboard</Link></nav>
        </div>
      </header>
      <main className="container mx-auto px-6 py-8">
        <div className="bg-gray-800 p-8 rounded-lg shadow-lg mb-8">
          <h2 className="text-3xl font-bold mb-6 text-magenta">{isEditing ? 'Edit Draft' : 'Create New Newsletter'}</h2>
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="mb-6">
              <label className="block text-gray-400 text-sm font-bold mb-2" htmlFor="subject">Subject Line</label>
              <input id="subject" type="text" value={formData.subject} onChange={handleInputChange} placeholder="e.g., Your Weekly Fitness Motivation" className="appearance-none block w-full bg-gray-700 text-white border border-gray-600 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-600 focus:border-magenta" />
            </div>
            <div className="mb-6">
              <label className="block text-gray-400 text-sm font-bold mb-2" htmlFor="body">Newsletter Body</label>
              <textarea id="body" rows="12" value={formData.body} onChange={handleInputChange} placeholder="Write your newsletter content here. You can include HTML." className="appearance-none block w-full bg-gray-700 text-white border border-gray-600 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-600 focus:border-magenta"></textarea>
            </div>
            <div className="mb-6 border-t border-gray-700 pt-6">
                <label className="block text-gray-400 text-sm font-bold mb-2">Schedule for later (optional)</label>
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label htmlFor="scheduleDate" className="text-xs text-gray-500">Date</label>
                        <input id="scheduleDate" type="date" value={formData.scheduleDate} onChange={handleInputChange} className="appearance-none block w-full bg-gray-700 text-white border border-gray-600 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-600 focus:border-magenta" />
                    </div>
                     <div>
                        <label htmlFor="scheduleTime" className="text-xs text-gray-500">Time</label>
                        <input id="scheduleTime" type="time" value={formData.scheduleTime} onChange={handleInputChange} className="appearance-none block w-full bg-gray-700 text-white border border-gray-600 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-600 focus:border-magenta" />
                    </div>
                </div>
            </div>
            <div className="flex justify-between items-center">
                <p className="text-gray-400">This will be sent to all registered subscribers.</p>
                <div className="flex items-center gap-4">
                    {isEditing && <button type="button" onClick={handleCancelEdit} className="bg-gray-600 text-white font-bold py-3 px-6 rounded-lg hover:bg-gray-500 transition">Cancel</button>}
                    <button onClick={() => handleSubmit('Draft')} className="bg-lime text-black font-bold py-3 px-6 rounded-lg hover:bg-opacity-80 transition glow-lime" type="button">Save Draft</button>
                    <button onClick={() => handleSubmit('Sent')} className="bg-magenta text-black font-bold py-3 px-6 rounded-lg hover:bg-opacity-80 transition glow-magenta" type="button">{formData.scheduleDate ? 'Schedule Send' : 'Send Now'}</button>
                </div>
            </div>
          </form>
        </div>
        <div>
          <h2 className="text-3xl font-bold mb-6 text-lime">Sent Newsletters & Drafts</h2>
          <div className="bg-gray-800 rounded-lg shadow-lg overflow-x-auto">
            <table className="w-full text-left">
              <thead className="bg-black">
                <tr>
                  <th className="p-4 font-bold">Date</th><th className="p-4 font-bold">Subject</th><th className="p-4 font-bold">Status</th>
                  <th className="p-4 font-bold">Recipients</th><th className="p-4 font-bold text-right">Actions</th>
                </tr>
              </thead>
              <tbody>
                {newsletters.map((item, index) => (
                  <tr key={item.id} className={index % 2 === 0 ? 'bg-gray-800' : 'bg-gray-700'}>
                    <td className="p-4 border-t border-gray-700">{item.date}</td><td className="p-4 border-t border-gray-700">{item.subject}</td>
                    <td className="p-4 border-t border-gray-700">
                        <span className={`px-2 py-1 text-sm font-bold rounded-full ${item.status === 'Sent' ? 'bg-lime text-black' : 'bg-yellow-500 text-black'}`}>{item.status}</span>
                    </td>
                    <td className="p-4 border-t border-gray-700">{item.recipients}</td>
                    <td className="p-4 border-t border-gray-700 text-right">
                      <button onClick={() => handleView(item)} className="text-gray-400 hover:underline mr-4">View</button>
                      {item.status === 'Draft' && (
                        <>
                          <button onClick={() => handleEdit(item)} className="text-lime hover:underline mr-4">Edit</button>
                          <button onClick={() => handleDelete(item.id)} className="text-magenta hover:underline">Delete</button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-gray-800 rounded-lg shadow-xl p-8 max-w-2xl w-full">
            <h2 className="text-2xl font-bold text-magenta mb-4">{viewingNewsletter.subject}</h2>
            <div className="text-gray-300 whitespace-pre-wrap">{viewingNewsletter.body}</div>
            <button onClick={() => setIsModalOpen(false)} className="mt-6 bg-lime text-black font-bold py-2 px-4 rounded-lg hover:bg-opacity-80 transition">Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default NewsletterPage;
